import $ from 'jquery';
import * as Utils from 'lib/utils';

const W = window;
const $W = $(window);

const READ_NOTIFICATION = `
  mutation readNotification($id: Int!) {
    read: readNotification(id: $id)
  }
`;

const READ_ALL_NOTIFICATION = `
  mutation readAllNotifications {
    read: readAllNotifications
  }
`;

const GET_UNREAD_NOTIFICATIONS = `
  query getUnreadNotifications {
    notifications: getUnreadNotifications {
      id
      type
      message
      data
      created_at
      unread_count
    }
  }
`;

$.onAuth(({ authenticated, website, user }) => {
  if (authenticated) {
    const $btn = $('.btn-notification');
    const $popover = $('#notifications-popover');
    const $unread = $('.app-header .badge-notification');
    let unread = user.unread_notifications;

    $unread.text(unread).toggleClass('d-none', unread <= 0);

    $btn
      .on('show.bs.popover', async evt => {
        const loaded = $btn.data('loaded');

        if (loaded !== true) {
          evt.preventDefault();

          const { notifications } = await $.GraphQL.runQuery(GET_UNREAD_NOTIFICATIONS, { operationName: 'getUnreadNotifications' });

          unread = notifications.length ? notifications[0].unread_count : 0;
          $unread.text(unread).toggleClass('d-none', unread <= 0);
          $popover.render('notifications_popover', notifications, Utils);
          $btn.data('loaded', true).popover('show');
        }
      })

      .on('shown.bs.popover', () => {
        $btn.data('loaded', false);
      });

    $popover.on('click', '.btn-read-all', async evt => {
      const { read } = await $.GraphQL.runQuery(READ_ALL_NOTIFICATION, { operationName: 'readAllNotifications' });

      if (read) {
        $unread.text(0).addClass('d-none');
        $popover.find('.notifications').empty().append('<div class="text-center p-2">You have no unread notifications</div>');
        $popover.find('.row').remove();
      }
    });

    $popover.on('click', '.notification', async evt => {
      const $notification = $(evt.target).closest('.notification');
      const $btn = $(evt.target).closest('.btn');
      const is_read = $notification.data('is_read');
      const notify_id = $notification.data('id');

      if (is_read !== true) {
        const { read } = await $.GraphQL.runQuery(READ_NOTIFICATION, { variables: { id: notify_id }, operationName: 'readNotification' });

        if (read) {
          unread--;
          $unread.text(unread).toggleClass('d-none', unread <= 0);
          $notification.data('is_read', true);
        }
      }

      if ($btn.length && $btn.attr('target')) $notification.trigger('click');

      $notification.slideOut({
        duration: 500,
        easing: 'easeOutExpo',
        complete: () => {
          const $notifications = $notification.parent();

          $notification.remove();

          if ($notifications.children('.notification').length === 0) {
            $notifications.empty().append('<div class="text-center p-2">You have no unread notifications</div>');
            $popover.find('.row').remove();
          }
        },
      });
    });

    $.subscribe(
      [
        { type: 'discrete', name: 'notify' },
        { type: 'discrete', name: `notify:${user.id}` },
      ],
      (channel, payload) => {
        const { notify_id, user_id, timeout = 0, type = 'info', message, data } = payload;
        const buttons = [];

        if (type === 'command') {
          switch (message) {
            case 'theme': {
              let $theme = $('style#theme');
              let $meta = $('meta[name=theme-color], meta[name=msapplication-navbutton-color], meta[name=apple-mobile-web-app-status-bar-style]');

              if (!$theme.length) $theme = $('<style></style>').attr('id', 'theme').appendTo('head');
              if (!$meta.length) $meta = $('<meta name="theme-color"/><meta name="msapplication-navbutton-color"/><meta name="apple-mobile-web-app-status-bar-style"/>').appendTo('head');

              $meta.attr('content', data.primary);
              $theme.html(
                `:root { ${Object.entries(Utils.omit(data, 'uri'))
                  .map(([k, v]) => `--${k}: ${v};`)
                  .join(' ')} }
                `,
              );

              break;
            }

            case 'logrocket': {
              $W.trigger('logrocket', data);
              break;
            }

            case 'reload':
              location.reload();
              break;

            case 'logout':
              location.href = Utils.baseUri('/logout');
              break;
          }

          return;
        }

        if (user_id) {
          unread++;
          $unread.text(unread).removeClass('d-none');
        }

        if (data) {
          if (data.auction_id)
            buttons.push(`
              <a href="${Utils.baseUri(`/?auction_id=${data.auction_id}&items=all`)}" class="btn btn-sm">
                <i class="fas fa-table mr-2"></i>
                <span>Go to Auction</span>
              </a>
            `);
          if (data.lot_id)
            buttons.push(`
              <a href="${Utils.baseUri(`/lot/${data.lot_id}`)}" class="btn btn-sm">
                <i class="fas fa-table mr-2"></i>
                <span>Go to Lot</span>
              </a>
            `);

          if (data.product_id)
            buttons.push(`
              <a href="${Utils.baseUri(`/product/${data.product_id}`)}" class="btn btn-sm">
                <i class="fas fa-table mr-2"></i>
                <span>Go to Product</span>
              </a>
            `);

          if (data.listing_id)
            buttons.push(`
              <a href="${Utils.baseUri(`/listing/${data.listing_id}`)}" class="btn btn-sm">
                <i class="fas fa-table mr-2"></i>
                <span>Go to Listing</span>
              </a>
            `);
        }

        $.toastr({
          timeout,
          type,
          message,
          buttons,
          onclick: async evt => {
            const $toast = $(evt.target).closest('.toast');
            const $btn = $(evt.target).closest('.btn');
            const is_read = $toast.data('is_read');

            if (notify_id && is_read !== true) {
              const { read } = await $.GraphQL.runQuery(READ_NOTIFICATION, { variables: { id: notify_id }, operationName: 'readNotification' });

              if (read) {
                unread--;
                $unread.text(unread).toggleClass('d-none', unread <= 0);
                $toast.data('is_read', true);
              }
            }

            if ($btn.length && $btn.attr('target')) $toast.trigger('click');
          },
        });
      },
    );
  }
});
